// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// // import { Link } from 'react-router-dom';

// import MainPage from "./MainPage";
// import ExteriorService from './pages/exteriordetail';
// import CeilingCoatingService from './pages/ceilingcoating';
// import InteriorPaintingService from './pages/interiorpaint';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<MainPage />} />
//         <Route path="./pages/exteriordetail.jsx" element={<ExteriorService />} />
//         <Route path="./pages/ceilingcoating.jsx" element={<CeilingCoatingService />} />
//         <Route path="./pages/interiorpaint.jsx" element={<InteriorPaintingService />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import Home from './pages/Home';
// import About from './pages/About';
// import Gallery from './pages/Gallery';
// import Contact from './pages/Contact';
// import Navbar from './components/Navbar';
// import './App.css';
// import ServiceCard from './components/ServiceCard';
// import Services from './pages/Services';

// export default function App() {
//   const services = [
//     {
//       title: "Commercial Painting",
//       shortDesc: "High-quality paint for offices and buildings.",
//       fullDesc: "We provide durable commercial painting solutions for offices, malls, and industrial interiors.",
//       image: "/Gallerypics/photo-1454165804606-c3d57bc86b40.jpeg",
//       id: "interior"
//     },
//     {
//       title: "Ceiling Coating",
//       shortDesc: "Expert coatings for ceilings and interiors.",
//       fullDesc: "Coating designed for ceilings in homes, marquees, commercial and factory spaces.",
//       image: "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       id: "ceiling"
//     },
//     {
//       title: "Exterior Projects",
//       shortDesc: "Durable and stylish outdoor painting.",
//       fullDesc: "Specialized in weather-resistant exterior coatings for commercial buildings, factories, and warehouses.",
//       image: "/Gallerypics/photo-1693691738879-e999316da868.jpeg",
//       id: "exterior"
//     }
//   ];

//   return (
//     <Router>
//       <div className="min-h-screen bg-gray-50 text-gray-800">
//         <Navbar/>

//         <Routes>
//           <Route path="/" element={
//             <div style={{ padding: '40px 20px', backgroundColor: '#f2f5fa', textAlign: 'center' }}>
//               <h2 style={{ color: '#003366', marginBottom: '30px', fontSize: '28px' }}>Our Services</h2>
//               <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
//                 {services.map((s, i) => (
//                   <ServiceCard
//                     key={i}
//                     title={s.title}
//                     shortDesc={s.shortDesc}
//                     fullDesc={s.fullDesc}
//                     image={s.image}
//                     id={s.id}
//                   />
//                 ))}
//               </div>

//               {/* Expanded Sections with Galleries */}
//               {services.map((s, i) => (
//                 <div key={i} id={s.id} style={{ marginTop: '80px' }}>
//                   <h2>{s.title} - Gallery</h2>
//                   <p>{s.fullDesc}</p>
//                   <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '20px' }}>
//                     {[...Array(10)].map((_, j) => (
//                       <img
//                         key={j}
//                         src={`/Gallerypics/${s.id}${j + 1}.jpg`}
//                         alt={`${s.title} ${j + 1}`}
//                         style={{ width: '200px', borderRadius: '8px' }}
//                         onError={(e) => { e.target.style.display = 'none'; }}
//                       />
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           } />
//           <Route path="/about" element={<About />} />
//           <Route path="/Services.jsx" element={<Services/>} />

//           <Route path="/gallery" element={<Gallery />} />
//           <Route path="/contact" element={<Contact />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// import { BrowserRouter as  Routes, Route,  } from 'react-router-dom';
// import Home from './Home';
// import About from './pages/About';
// import Gallery from './pages/Gallery';
// import Contact from './pages/Contact';
// // import Footer from './components/Footer';
// // import MainPage from './MainPage';
// // import ServiceDetail from './pages/ServiceDetail';
// import './App.css';
// // import ServiceCard from './components/ServiceCard';
// // import Navbar from './pages/Navbar';
// import Services from './pages/Services';
// // import Exteriordetail from './pages/exteriordetail';
// // import Hero from './pages/Hero';

// export default function App() {

//   return (
//     // <Router>
//     //   {/* <div className="app-wrapper"> */}
       
//     //     {/* <Navbar/> */}
        
        
//     //     <Routes>
//     //         {/* <Route path='/home' element={<MainPage/>}></Route> */}
//     //         <Route path="/" element={<Home/>}></Route>
//     //       <Route path="/about" element={<About />} />
//     //       <Route path="/gallery" element={<Gallery />} />
//     //       <Route path="/contact" element={<Contact />} />
//     //       <Route path="/services" element={<Services/>} />
//     //       <Route path="/exterior" element={<Exteriordetail/>}></Route>
//     //       <Route path="/services/:id" element={<ServiceDetail />} />
          

 

//     //     </Routes>
//     //     {/* <Footer/> */}
//     //   {/* </div> */}
//     // </Router>
//     <Routes>
//   <Route path="/" element={<Home />} />
//   <Route path="/about" element={<About />} />
//   <Route path="/services" element={<Services />} />
//   <Route path="/gallery" element={<Gallery />} />
//   <Route path="/contact" element={<Contact />} />
// </Routes>
//   );
// }

import { Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import Home from './Home';
import Loader from './pages/loader';
import About from './pages/About';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Labour from './pages/labour';
// import SocialWidget from './components/SocialWidget';
// import SocialDock from './components/Socialdock';
import OurGoal from './pages/Ourgoal';
import Navbar from './pages/Navbar';
// import ServiceDetail from './pages/ServiceDetail';
import Footer from './components/Footer';
// import socialIcons from './components/Socialicons';
import ResidentialInterior from "./services/interiorpaint";
import ExteriorDetail from "./services/exteriordetail";
import CeilingCoating from './services/ceilingcoating';
import FlourMills from './services/flourmills';
import GamesAreaCoating from './services/gamesarea';
import MarqueePainting from './services/marqueeService';
import ServiceDetail from "./pages/ServiceDetail";
import ThankYou from './pages/Thank-you';
import WhatsAppWidget from './components/WhatsappWidget';
import NotFound from './pages/404page';
import './App.css';

export default function App() {
   const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500); // loader time
    return () => clearTimeout(timer);
  }, []);

   useEffect(() => {
    const imgs = document.querySelectorAll("img");
    let loaded = 0;

    if (imgs.length === 0) {
      setLoading(false);
      return;
    }

    imgs.forEach((img) => {
      if (img.complete) {
        loaded++;
        if (loaded === imgs.length) setLoading(false);
      } else {
        img.onload = () => {
          loaded++;
          if (loaded === imgs.length) setLoading(false);
        };
        img.onerror = () => {
          loaded++; // still count failed images
          if (loaded === imgs.length) setLoading(false);
        };
      }
    });
  }, []);
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path='/about/labour' element={<Labour/>}/>
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<ServiceDetail />} />
        <Route path="/services/interior" element={<ResidentialInterior />} />
        <Route path="/services/exterior" element={<ExteriorDetail />} />
        <Route path="/services/ceiling" element={<CeilingCoating />} />
        <Route path="/services/flour" element={<FlourMills />} />
        <Route path="/services/marquee" element={<MarqueePainting />} />
        <Route path="/services/games" element={<GamesAreaCoating />} />
         <Route path="/services/:id" element={<ServiceDetail />} />
         <Route path="/thankyou" element={<ThankYou />} />
         <Route path='/Ourgoal' element={<OurGoal/>}/>
         <Route path='*' element={<NotFound/>}/>



       </Routes>
       {/* <SocialWidget/> */}
       {/* <SocialDock/> */}
       <WhatsAppWidget/>
       <Footer />
     </>
   );
 }

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Services from "./pages/Services";
// import ResidentialInterior from "./services/interiorpaint";
// import CommercialInterior from "./services/commercial";
// import TextureFinishes from "./services/exteriordetail";
// import ColorConsultation from "./services/marqueeService";


// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/services" element={<Services />} />
//         <Route path="/services/residential" element={<ResidentialInterior />} />
//         <Route path="/services/commercial" element={<CommercialInterior />} />
//         <Route path="/services/texture" element={<TextureFinishes />} />
//         <Route path="/services/color" element={<ColorConsultation />} />
      
//       </Routes>
//     </Router>
//   );
// }

// export default App;

